<!--
 * @Description: 新增角色
 * @Autor: lwq
 * @Date: 2020-07-01 11:19:46
 * @LastEditors: lwq
 * @LastEditTime: 2020-07-31 11:37:01
-->
<template>
  <div>
    <!-- @nextStep='nextStep' -->
    <!-- @prevStep='prevStep' -->
    <mrc_ess_myStep :list="list"
                    v-model="step">
      <template v-slot:1>
        <component :is="baseSet"
                   @success="success1"
                   @cancel="cancel1"
                   :laoding="loading"
                   :successText="$t('label_The_next_step')"
                   :cancelText="$t('label_cancel')"
                   ref="baseSet"
                   :disabled="false"></component>
      </template>
      <template v-slot:2>
        <component ref="funcSet"
                   :is="funcSet"
                   :laoding="loading"
                   @success="success2"
                   @cancel="cancel2"
                   :successText="$t('label_submit')"
                   :cancelText="$t('label_The_previous_step')"
                   :disabled="false"></component>
      </template>
    </mrc_ess_myStep>
  </div>
</template>

<script>
import baseSet from '../components/baseSet'
import funcSet from '../components/funcSet'
import { role_add } from '@/service/api/role'
export default {
  components: {},
  props: {},
  data () {
    return {
      step: 1,
      loading: false,
      baseSet: baseSet,
      funcSet: funcSet,
      list: [
        {
          name: this.$t('label_base_set'),
        },
        {
          name: this.$t('label_Functional_authority'),
        },
      ],
      params: {},
      mrbase_sys_function_permission: [],
    }
  },
  created () { },
  mounted () { },
  methods: {
    async addHandle () {
      if (this.$refs.funcSet.eleTree().length <= 0) {
        this.$Message({
          text: this.$t(
            'message_permission_list_must_select_at_least_one_item'
          ),
        })
        return
      }
      const obj = Object.assign({}, this.params, {
        mrbase_sys_function_permission: this.$refs.funcSet.eleTree(),
      })
      this.loading = true
      const addrole = await role_add(obj)
      if (addrole.code == 200) {
        this.$Message({ text: this.$t('message_The_operation_was_successful') })
        this.$router.go(-1)
      }
      this.loading = false
    },
    // 基本设置变化
    success1 (val) {
      this.params = Object.assign({}, val)
      this.step++
    },
    cancel1 () {
      this.$myConfirm({
        content: this.$t('message_Confirm_the_cancellation_of_the_edit'),
      })
        .then(() => {
          this.$router.go(-1)
        })
        .catch(() => { })
    },
    success2 () {
      this.addHandle()
    },
    cancel2 () {
      this.step--
    },
    funcSetChange (val) {
      this.mrbase_sys_function_permission = val
    },
  },
  computed: {},
  watch: {},
}
</script>

<style scoped></style>
